export const PER_PAGE_FOR_PROFILES = 24;
export const PER_PAGE_FOR_PAGES = 8;
